import solution1 from "../assets/1.svg";
import solution2 from "../assets/2.svg";
import solution3 from "../assets/3.svg";
import solution4 from "../assets/4.svg";
import solution6 from "../assets/6.svg";

export type ServiceItem = {
    slug: string;
    title: string;
    headingColor: string;
    tagline: string;
    description: string;
    image: string;
    imagePosition: "left" | "right";
    desktopImageType: "img" | "svg";
};

export const solutions: ServiceItem[] = [
    {
        slug: "website-development",
        title: "Website Development",
        headingColor: "#9e00ff",
        tagline: "Modern design, seamless functionality",
        description:
            "We help businesses thrive online by building beautiful, user-friendly websites that convert visitors into loyal customers.",
        image: solution1,
        imagePosition: "left",
        desktopImageType: "img",
    },
    {
        slug: "mobile-app-development",
        title: "Mobile App Development",
        headingColor: "#002454",
        tagline: "Innovate, Develop, Succeed",
        description:
            "We bridge the gap between your mobile app idea and its successful launch. We collaborate with businesses to develop user-friendly apps that make a real impact.",
        image: solution2,
        imagePosition: "right",
        desktopImageType: "svg",
    },
    {
        slug: "digital-marketing",
        title: "Digital Marketing",
        headingColor: "#9e00ff",
        tagline: "Targeted Reach, Measurable Impact",
        description:
            "We help businesses amplify their online presence. We develop data-driven digital marketing strategies that attract new customers and drive business growth.",
        image: solution3,
        imagePosition: "left",
        desktopImageType: "img",
    },
    {
        slug: "post-editing",
        title: "Post Editing",
        headingColor: "#002454",
        tagline: "Level Up Your Content",
        description:
            "We take the stress out of social media. We edit your content to perfection, ensuring your brand voice shines through and resonates with your target audience.",
        image: solution4,
        imagePosition: "right",
        desktopImageType: "svg",
    },
    {
        slug: "video-editing",
        title: "Video Editing",
        headingColor: "#002454",
        tagline: "Seamless Edits, Stunning Results",
        description:
            "Stop struggling with editing – start captivating your audience! We offer professional video editing services for social media, helping you create stunning content that gets results. We handle the editing, so you can focus on building your brand.",
        image: solution6,
        imagePosition: "right",
        desktopImageType: "img",
    },
];

export const getSolutionBySlug = (slug: string) =>
    solutions.find((item) => item.slug === slug);
